import Vue from 'vue'
import GetText from 'vue-gettext'
import convertPlugin from '@/plugins/convert'

import translations from '@/locale/translations'

export default () => {
  Vue.use(GetText, {
    availableLanguages: {
      ca: 'Català',
      cs: 'Čeština',
      'zh-hk': '中文',
      de: 'Deutsch',
      el: 'ελληνικά',
      en: 'English',
      es: 'Español',
      eu: 'Euskara',
      fr: 'Français',
      it: 'Italiano',
      hu: 'Magyar',
      nl: 'Nederlands',
      pl: 'Polskie',
      pt: 'Português ',
      ro: 'Română',
      ru: 'Русский',
      sl: 'Slovenščina'
    },
    defaultLanguage: 'en',

    silent: true,

    translations
  })
}

const autoRound = v => v >= 10 ? Math.round(v) : Number(Math.round(v + 'e+1') + 'e-1')

export const convert = Vue.use(convertPlugin, {
  availableUnits: {
    ms: 'm/s',
    kmh: 'km/h',
    mph: 'mph',
    knots: 'knots',
    bft: 'bft'
  },
  defaultUnit: 'kmh',

  conversions: {
    kmh: v => autoRound(v * 3.6),
    ms: v => autoRound(v), // eslint-disable-line no-mixed-operators
    knots: v => autoRound(v * 3.6 / 1.852), // eslint-disable-line no-mixed-operators
    mph: v => autoRound(v * 3.6 / 1.609), // eslint-disable-line no-mixed-operators
    bft: v => (v * 3.6) >= 118 ? 12 : (v * 3.6) < 1 ? 0 : Math.round(Math.cbrt(Math.pow((v * 3.6), 2) / 9)) // eslint-disable-line no-mixed-operators
  }
})



// WEBPACK FOOTER //
// ./src/locale/index.js